import Icon from '@/legacy-src/components/icons/Icon'
import { Button } from '@/legacy-src/components/ui/button'
import { useToggleState } from '@/legacy-src/hooks/useToggleState'
import { getTranslate } from '@/legacy-src/utilities/i18n'
import { getFullName } from '@/legacy-src/utilities/name'

import { useGetTherapistData } from '@/src/domains/therapist/hooks/useGetTherapistData'

export interface TherapistBioBillingInfoProps {
  therapistUserId: number
}

export const TherapistBioBillingInfo = ({ therapistUserId }: TherapistBioBillingInfoProps) => {
  const { data: therapistDetail } = useGetTherapistData(therapistUserId, {
    suspense: true,
  })

  const [visible, toggle] = useToggleState(false)

  const { firstName, lastName, titleBefore, titleAfter, billingInfo } = therapistDetail

  if (!billingInfo || !firstName || !lastName) {
    return null
  }

  const { t } = getTranslate()

  const therapistName = getFullName({
    person: { firstName, lastName },
    titleAfter: titleAfter ?? undefined,
    titleBefore: titleBefore ?? undefined,
  })

  return (
    <div className="mb-20">
      <div className="mb-4 mt-8 flex items-center justify-between">
        <div className="text-xl font-bold text-text-color">{t('component.invoices.download.invoicingData')}</div>
        <div>
          <Button
            className="m-0 flex items-center p-0 capitalize text-peach-500 underline focus:shadow-none"
            variant="inline"
            onClick={toggle}
          >
            {t(`general.${visible ? 'hide' : 'show'}`)}
            <Icon icon="select-arrow" size="xs" color="primary" className={`ml-2 ${visible ? 'rotate-180' : ''}`} />
          </Button>
        </div>
      </div>
      {visible ? (
        <>
          <div className="font-bold text-petrol-500">{therapistName}</div>
          <div className="text-sm">
            {`${billingInfo.street} ${billingInfo.houseNumber}, ${billingInfo.zip}, ${billingInfo.city}`}
            <br />
            {billingInfo.country}
            <br />
            <br />
            {`${t('component.invoices.download.cin')}: ${billingInfo.cin}`}
          </div>
          {billingInfo.vatin && (
            <div className="text-sm"> {`${t('component.invoices.download.vatin')}: ${billingInfo.vatin}`}</div>
          )}
        </>
      ) : null}
    </div>
  )
}
